<template>
    <v-container>
        <user-details v-model="detailsDialog" :key="`${this.selectedUser ? `edit_${this.selectedUser.id}` : -1}`"
                       :user="this.selectedUser" @close="this.closeDialog"></user-details>
        <user-delete-confirmation v-model="this.showDeleteConfirmation"
                                  :key="`delete_${this.selectedUser ? this.selectedUser.id : -2}`"
                                  :user="this.selectedUser"
                                  @delete="this.reallyDeleteUser"
                                  @close="this.closeDeleteConfirmation">

        </user-delete-confirmation>
      <h4 class="align-left pa-2 section-title">{{ currentRouteName }}</h4>
      <v-card>
        <v-card-title>
          <v-row>
          <v-col cols="12" md="6">
            <v-text-field
                v-model="searchUsers"
                label="Liste durchsuchen"
                append-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
            <v-col cols="12" md="6" class="text-right">
              <v-btn color="primary"
                     @click="createUser"> + Neuer Nutzer</v-btn>
            </v-col>
          </v-row>

        </v-card-title>
        <v-data-table
                :headers="headers"
                :options="tableOptions"
                :loading="isLoading"
                loading-text="Daten werden geladen .. Bitte warten"
                :items="displayUsers"
                class="elevation-1"
                mobile-breakpoint="0"
        >
            <template v-slot:item="row">
                <user-row :user="row.item" @edit="editUser" @delete="deleteUser"></user-row>
            </template>
        </v-data-table>
      </v-card>
    </v-container>
</template>
<!-- TODO change lang to ts instead js to enable typescript-->
<script lang="js">
    import usersApi from '../api/users';
    import ErrorStore from "@/stores/ErrorStore";
    import UserRow from "../components/UserRow";
    import UserDetails from "@/views/UserDetails";
    import UserDeleteConfirmation from "@/components/UserDeleteConfirmation";
    import RouteInfo from "@/utils/RouteInfo";

    export default {
        extends: RouteInfo,
        name: "UserManagement",
        components: {UserDetails, UserRow, UserDeleteConfirmation},
        data: () => {
            return {
                users: [],
                detailsDialog: false,
                selectedUser: null,
                showDeleteConfirmation: false,
                searchUsers: null,
                tableOptions: {
                  itemsPerPage: 10
                },
                headers: [
                    { text: 'Name', value: 'fullname', align: 'left'},
                    { text: 'Benutzername', value: 'email', align: 'left' },
                    { text: 'Rolle', value: 'role.name', align: 'left' },
                    { text: 'Optionen' , value:'options', align: 'right' }
                ],
              isLoading: false
            }
        },
        computed: {
            displayUsers () {
                if ([null, undefined, ''].includes(this.searchUsers)) {
                    return this.users
                }
                const search = this.searchUsers.toLowerCase()
                return this.users.filter(u => {
                    return u.email.toLowerCase().includes(search) || u.fullname.toLowerCase().includes(search)
                })
            }
        },
        mounted() {
            this.getAllUsers()
        },
        methods: {
            getAllUsers() {
              this.users = []
              this.isLoading = true
                usersApi.listUsers()
                    .then(r => {
                      this.users = r.data
                      this.isLoading = false
                    })
                    .catch(err => {
                      this.isLoading = false
                      if (err.status === 403) {
                          ErrorStore.showError('Sie haben keine Berechtigung, sich diesen Bereich einzusehen')
                      }
                    })
            },
            editUser (user) {
                this.selectedUser = user
                this.detailsDialog = true
            },
            deleteUser (user) {
                this.selectedUser = user
                this.showDeleteConfirmation = true
            },
            closeDialog () {
                this.detailsDialog = false
                this.selectedUser = null
                this.getAllUsers()
            },
            createUser() {
                this.selectedUser = null
                this.detailsDialog = true
            },
            closeDeleteConfirmation () {
                this.showDeleteConfirmation = false
                this.selectedUser = null
            },
            reallyDeleteUser () {
                this.showDeleteConfirmation = false
                usersApi.deleteUser({
                        email: this.selectedUser.email
                }).then(_ =>{
                    ErrorStore.showErrorMessage('Nutzer wurde gelöscht', 'Info')
                    this.getAllUsers()
                })
                .catch(err => ErrorStore.showError(err.response.data))
            }
        }
    }
</script>

<style scoped>
.table_headers {
  font-size: 36px;
}
</style>